import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Cookies } from 'react-cookie'

import { AuthState, EmptyAuthState } from '../../Models/Auth'
import { cookieOptions } from '../../Services/constants'

const InitializeAuthState = (): AuthState => {
  const cookies = new Cookies()
  const token = cookies.get('accessToken')
  const refreshToken = cookies.get('refreshToken')

  return { token: token || '', refreshToken: refreshToken || '' }
}

export const authSlice = createSlice({
  name: 'Auth',
  initialState: InitializeAuthState(),
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      const accessToken = action.payload
      const cookies = new Cookies()

      cookies.set('accessToken', accessToken, cookieOptions)
      state.token = accessToken
    },
    setTokens: (state, action: PayloadAction<{ accessToken: string; refreshToken: string }>) => {
      const { accessToken, refreshToken } = action.payload
      const cookies = new Cookies()

      cookies.set('accessToken', accessToken, cookieOptions)
      cookies.set('refreshToken', refreshToken, cookieOptions)
      state.token = accessToken
      state.refreshToken = refreshToken
    },
    clearToken: (state) => {
      const cookies = new Cookies()

      cookies.remove('accessToken', { path: '/' })
      cookies.remove('refreshToken', { path: '/' })
      state.token = ''
      state.refreshToken = ''
    },
  },
})

export const { setToken, setTokens, clearToken } = authSlice.actions

export default authSlice.reducer
